import React from "react";
import "./DShieldPro_Testimonial.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, A11y } from "swiper/modules";
import { EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/swiper-bundle.css";

import TestimonialIcon from "../../../Img/testi-icon.png";
import Vinayak from "../../../Img/dshield/Testimonial/Vinayak.png";
import Deepak from "../../../Img/dshield/Testimonial/deepak.jpg";
import Ankit from "../../../Img/dshield/Testimonial/ankit.jpg";

const testimonials = [
 {
  image: Vinayak,
text: "Dshield Pro is the perfect companion for managing EMI. Its lock-unlock features are intuitive and efficient, saving my time and worry.",
name: "Vinayak Mobile Shahpura",
designation: "(Authorized Adviser)"
},
{
image: Deepak,
text: "Dshield Pro ensures timely EMI management with its smart auto-lock and unlock features. It’s reliable and stress-free for financial planning.",
name: "Deepak Kumawat",
designation: "(Authorized Adviser)"
},
{
image: Ankit,
text: "With Dshield Pro, handling EMI payments has never been easier. Its seamless unlocking after payments makes it the ideal financial companion.",
name: "Ankit",
designation: "(Authorized Adviser)"
}
  // Add more testimonials as needed
];
const Testimonial = () => {

  return (
    <div class="section bg-cover harsafe-testimonial-section-02 section-padding">
      <div class="container">
        {/* <!-- Testimonial Wrap Start  --> */}
        <div class="testimonial-wrap-02">
          <div class="section-title text-center">
            <h3 class="sub-title">Testimonial</h3>
            <h2 class="title">20k+ satisfied clients worldwide</h2>
          </div>
          <div class="testimonial-content-wrap-02">
            <div class="swiper-container testimonial-02-active">
              <Swiper
                // install Swiper modules
                modules={[Pagination, A11y]}
                spaceBetween={50}
                slidesPerView={2}
                loop={true}
                effect="fade"
speed={900}
                // navigation
                pagination={{ clickable: true }}
                // scrollbar={{ draggable: true }}
                // onSwiper={(swiper) => console.log(swiper)}
                // onSlideChange={() => console.log("slide change")}
                breakpoints={{
                    0: {
                      slidesPerView: 1,
                    },
                    639: {
                      slidesPerView: 1,
                    },
                    1400:{
                      slidesPerView:2
                    }
                  }}
              >
                
                {testimonials.map((testimonial, index) => (
                  <SwiperSlide key={index}>
                    <div className="swiper-slide">
                      {/* Single Testimonial Start */}
                      <div className="single-testimonial-02">
                        <div className="testimonial-thumb">
                          <img src={testimonial.image} alt={testimonial.name} />
                        </div>
                        <div className="testimonial-content">
                          <img src={TestimonialIcon} alt="Icon" />
                          <p>{testimonial.text}</p>
                          <span className="name">{testimonial.name}</span>
                          <span className="designation">{testimonial.designation}</span>
                        </div>
                      </div>
                      {/* Single Testimonial End */}
                    </div>
                  </SwiperSlide>
                ))}


                {/* <SwiperSlide>Slide 4</SwiperSlide> */}

              </Swiper>

              {/* <!-- Add Pagination --> */}
              <div class="swiper-pagination"></div>
            </div>
          </div>
        </div>
        {/* <!-- Testimonial Wrap End  --> */}
      </div>
    </div>
  );
};

export default Testimonial;
